import { mapDTO } from '@twistezo/ts-dto-mapper'

import { JSON_SPACE } from 'constants/json'
import { floatPercentFromDTO } from 'utils/number'
import { WorkspaceBidderSlice } from '../types'
import { WorkspaceBidderSliceDTO } from './types'

type From = WorkspaceBidderSliceDTO
type To = WorkspaceBidderSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((from: From): To => {
    const {
      accountType,
      bidCpmAdjustment,
      bidder,
      bidderCode,
      bidderConfig,
      bidderConfigEnabled,
      bidderSid,
      consentMode,
      enabled,
      id,
      priority,
      status,
      supplyChain,
    } = from

    return {
      accountType,
      bidCpmAdjustment: floatPercentFromDTO(bidCpmAdjustment),
      bidder,
      bidderCode,
      bidderConfig: JSON.stringify(bidderConfig, null, JSON_SPACE),
      bidderConfigEnabled,
      bidderSid: bidderSid || undefined,
      consentMode,
      enabled,
      id,
      priority,
      status,
      supplyChain,
    }
  })
